import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import * as ROUTES from '../../../constants/routes';

const MODULES = [
  {
    id: 'replan',
    icon: '📐',
    titleKey: 'home.replan_title',
    descriptionKey: 'home.replan_description',
    route: ROUTES.REPLAN,
    colorClass: 'primary',
  },
  {
    id: 'shapetakeoff',
    icon: '📊',
    titleKey: 'home.shapetakeoff_title',
    descriptionKey: 'home.shapetakeoff_description',
    route: ROUTES.SHAPELIST,
    colorClass: 'green',
  },
  {
    id: 'gantt',
    icon: '📅',
    titleKey: 'home.gantt_title',
    descriptionKey: 'home.gantt_description',
    route: ROUTES.GANTT_PLANNING,
    colorClass: 'orange',
  },
  {
    id: 'inventory',
    icon: '📦',
    titleKey: 'home.inventory_title',
    descriptionKey: 'home.inventory_description',
    route: ROUTES.INVENTORY,
    colorClass: 'purple',
  },
  {
    id: 'vcontrol',
    icon: '📄',
    titleKey: 'home.vcontrol_title',
    descriptionKey: 'home.vcontrol_description',
    route: ROUTES.VCONTROL,
    colorClass: 'teal',
  },
  {
    id: 'calculator',
    icon: '🧮',
    titleKey: 'home.calculator_title',
    descriptionKey: 'home.calculator_description',
    route: ROUTES.CALCULATOR,
    colorClass: 'secondary',
  },
];

const ModuleCards = ({ horizontal }) => {
  const { t } = useTranslation();

  if (horizontal) {
    return (
      <div className="home-module-toolbar">
        {MODULES.map(mod => (
          <Link key={mod.id} to={mod.route} className={`home-module-toolbar-item home-module-${mod.colorClass}`}>
            <span className="home-module-toolbar-icon">{mod.icon}</span>
            <span className="home-module-toolbar-label">{t(mod.titleKey)}</span>
          </Link>
        ))}
      </div>
    );
  }

  return (
    <div className="home-modules-grid">
      {MODULES.map(mod => (
        <Link key={mod.id} to={mod.route} className={`home-module-card home-module-${mod.colorClass}`}>
          <div className="home-module-icon">{mod.icon}</div>
          <div className="home-module-info">
            <strong>{t(mod.titleKey)}</strong>
            <span>{t(mod.descriptionKey)}</span>
          </div>
          <span className="home-module-arrow">→</span>
        </Link>
      ))}
    </div>
  );
};

export default ModuleCards;
